import { IReport6ReportingPeriod } from "../../../model/report/Report6ReportingPeriod";
import { DateService } from "../../../service/DateService";
import { IReport6Report } from "../../../model/report/Report6Report";
import Report6ReportPresentationModel, {
  TReport6ReportPresentationModel
} from "./Report6ReportPresentationModel";

export interface TReport6ReportingPeriodPresentationModel {
  reportingPeriodId: number;
  name: string;
  additionalEvaluation: boolean;
  additionalEvaluationReason: string;
  additionalEvaluationStatus: string;
  additionalEvaluationDate: string;
  applicantId: number;
  applicantReportingPeriodId: number;
  reports: TReport6ReportPresentationModel[];
}

const Report6ReportingPeriodPresentationModel = (
  data: IReport6ReportingPeriod
) => {
  const additionalEvaluationDate = data.additionalEvaluation
    ? DateService().formatDate(data.additionalEvaluationDate)
    : "";
  return {
    ...data,
    additionalEvaluationDate,
    reports: data.reports.map((report: IReport6Report) => {
      return Report6ReportPresentationModel(report);
    })
  };
};

export default Report6ReportingPeriodPresentationModel;
